import Header from "../../../components/header";
import LeftMenu from "../../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "../../../pages/PIList/api.js";
import {readEmpty} from "../../../pages/PIList/apiEmpty.js";
import Post from "../../../pages/PIList/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { HouseboatOutlined } from "@mui/icons-material";
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Mastertemplate from "./Mastertemplate";


export default function KontrakVO(){



    ///////Variable to Pass On to Contract Generator machine//////////
    const [sellerData,setSellerData] = useState([
        {namaPerusahaan:"PT. SUPARDI NETHANEL HUSAIN", alamat:"", nomorTelepon:""},
    ]);
    


    
    /////End Variable to Pass on to contract generator machine////////

    ///////Linear Progress Function///////////////////////////////////
    function LinearProgressWithLabel(props) {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2" color="text.secondary">{`${Math.round(
                props.value,
              )}%`}</Typography>
            </Box>
          </Box>
        );
      }
    ///////Functions for Seller Company///////////////////////////////
    const handleSellerCompany = (event) => {
        const values =[...sellerData];
        values.namaPerusahaan = event.target.value;
        setSellerData(values)
    };
    ///////End of Functions for Seller Company///////////////////////////////

    return <Grid container>
                
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} >
                    <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                            <Header></Header>
                    </Grid>
                    <Grid sx={{ mt:15}}></Grid>
                    <Mastertemplate></Mastertemplate>
                </Grid>
                <Button></Button>
                              
            </Grid>
    };